
"use strict";

var formValidation = require('app_custom_vinfast_ui/components/formValidation');
var createErrorNotification = require('app_custom_vinfast_ui/components/errorNotification');
var store = {
    rtr: []
};
var isRTRPage = false;

function validateEmail(email) {
    var regex = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,20})$/;
    return regex.test(email);
}

function validatePassword(password) {
    // var pattern = new RegExp(/^.*(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@$%^*_=+[{}/;:,.?-]).*$/); //10, lower, upper, special character
    const regexPassword = isRTRPage ? new RegExp(/^.*(?=.{12,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).*$/) : // 12, lower, upper, number and Special characters
                            new RegExp(/^.*(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/); // 10, lower, upper and number
    return regexPassword.test(password);
}

function getVerificationCodeAjax(url, email) {
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: { email: email },
        success: function (data) {
            if (!data.success) {
                $('.invalid-email').text(data.errorMessage);
                $('.invalid-email').css('display', 'block');
            } else {
                //$('.email-sent-text').html('<div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">An email has been sent to you. </p><p class="pb-3">Please check your inbox for instructions.</p></div>');
                if (window.location.href.indexOf("fr_FR") > -1) {
                    $(".email-sent-text").html('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">Un email vous a été envoyé.</p><p class="pb-3">Veuillez vérifier votre boîte de réception pour obtenir des instructions.</p></div></div>');;
                }
                else if (window.location.href.indexOf("nl_NL") > -1) {
                    $(".email-sent-text").html('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">Er is een e-mail naar u verzonden. </p><p class="pb-3">Controleer uw inbox voor instructies.</p></div></div>');
                }
                else if (window.location.href.indexOf("de_DE") > -1) {
                    $(".email-sent-text").html('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">Eine E-Mail wurde an Sie gesendet. </p><p class="pb-3">Bitte überprüfen Sie Ihren Posteingang nach Anweisungen.</p></div></div>');
                }
                else {
                    $(".email-sent-text").html('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">An email has been sent to you. </p><p class="pb-3">Please check your inbox for instructions.</p></div></div>');
                }
                $('#step-1-forgot-password').hide();
                $('.verification-code-element').css('display', 'block');
                $('#get-code-button').css('display', 'none');
            }

        },
        error: function (err) {

            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        }
    });
}
module.exports = {
    loginDisable: function () {
        $('form.login .required input').bind("change keyup input", function () {
            var empty = false;
            $(this).closest('form').find('.required input').each(function () {
                if ($(this).val() == '') {
                    empty = true;
                }
                if ($(this).hasClass("is-invalid")) {
                    empty = true;
                }
                if ($(this).val() != '') {
                    $(this).removeClass('is-invalid')
                }
            });
            if (empty) {
                $('.btn-login-submit').prop("disabled", true);
            } else {
                $('.btn-login-submit').prop("disabled", false);
            }
        });
    },

    registerDisable: function () {
        $('form.registration .required input, #salutation, .salutation_reg').bind("change keyup input", function () {

            var empty = false;
            $(this).closest('form').find('.required input, .required select').each(function () {
                if ($(this).val() == '') {
                    empty = true;
                }
                if (!$(".registration input[name='terms']:checkbox").is(':checked')) {
                    empty = true;
                }
                else { }

                $(this).find("option:selected").each(function () {
                    var optionValue = $(this).attr("id");
                    if (optionValue == undefined) {
                        empty = true;
                    }
                });

                // Validate form B2B customer when upload files
                if ($(this).attr('type') === 'file') {
                    if (store.rtr.length < 1) {
                        empty = true;
                    }
                }
            });


            $(".salutation_reg").change(function () {
                $(this).find("option:selected").each(function () {
                    var optionValue = $(this).attr("id");
                    if (optionValue == undefined) {
                        empty = true;
                    }
                    else { }
                });
            });


            if (empty) {
                $('.btn-registration-submit').prop("disabled", true);
            } else {
                $('.btn-registration-submit').prop("disabled", false);
            }
        });
        /*Register submit button one time click after Disable*/
        (function () {
            var timer = null;
            $('.btn-registration-submit').on('click', function () {
                $(this).css("pointer-events", "none");
                $(this).css("opacity", ".4");
                clearTimeout(timer); // clear the timer
                timer = setTimeout(func2, 4000); // run function2 1s later
            });
        })();
        function func2() {
            if ($(".registration input").hasClass("is-invalid")) {
                $(".btn-registration-submit").css("pointer-events", "auto");
                $(".btn-registration-submit").css("opacity", "1");
            }
            else {
                $(".btn-registration-submit").css("pointer-events", "none");
                $(".btn-registration-submit").css("opacity", ".4");
            }
        };

    },
    getVerificationCodeValidations: function () {
        $('#reset-password-email').bind("change keyup input", function () {
            if ($('#reset-password-email') !== "") {
                $('#get-code-button').prop('disabled', false);
            } else {
                $('#get-code-button').prop("disabled", false);
            }
        })
    },

    verifyVerificationCodeValidations: function () {
        $('#reset-verification-code').bind("change keyup input", function () {
            if ($('#reset-verification-code') !== "" || $('#reset-password-email') !== "") {
                $('#submitEmailButton').prop('disabled', false);
            } else {
                $('#submitEmailButton').prop("disabled", false);
            }
        })
    },

    registerFormValidations: function () {
        $(document).ready(function () {
            $(".regfirstname").on('keyup', function () {
                //var firstname1= $("#registration-form-fname").val();
                var firstname = $(this).val();
                //console.log(firstname);
                if (!(/^([^0-9&$£?!@#%;:`<>_+"|=~(^*/){[}\\\]-]*)$/.test(firstname))) {
                    if (window.location.href.indexOf("fr_FR") > -1) {
                        $(".regfirstname").addClass("is-invalid");
                        $(".reg-form-fname-alert").text("Veuillez entrer un nom valide");
                    }
                    else if (window.location.href.indexOf("nl_NL") > -1) {
                        $(".regfirstname").addClass("is-invalid");
                        $(".reg-form-fname-alert").text("Voer een geldige naam in");
                    }
                    else if (window.location.href.indexOf("de_DE") > -1) {
                        $(".regfirstname").addClass("is-invalid");
                        $(".reg-form-fname-alert").text("Bitte geben Sie einen gültigen Namen ein");
                    }
                    else {
                        $(".regfirstname").addClass("is-invalid");
                        $(".reg-form-fname-alert").text("Please enter a valid name");
                    }
                    $(".reg-form-fname-alert").css("display", "block");
                }
                else if (firstname == "") {
                    if (window.location.href.indexOf("fr_FR") > -1) {
                        $(".reg-form-fname-alert").text("Ce champ est obligatoire.");
                    }
                    else if (window.location.href.indexOf("nl_NL") > -1) {
                        $(".reg-form-fname-alert").text("Dit veld is verplicht.");
                    }
                    else if (window.location.href.indexOf("de_DE") > -1) {
                        $(".reg-form-fname-alert").text("Dieses Feld wird benötigt.");
                    }
                    else {
                        $(".reg-form-fname-alert").text("This field is required.");
                    }
                    $(".reg-form-fname-alert").css("display", "block");
                }
                else {
                    $(".regfirstname").removeClass("is-invalid");
                    $(".reg-form-fname-alert").css("display", "none");
                }
            });
            /*first name alert END*/
            /*Last name alert START*/
            $("input[name='dwfrm_profile_customer_lastname']").on('keyup', function () {
                var lastname = $(this).val();
                //console.log(lastname)
                if (!(/^([^0-9&$£?!@#%;:`<>_+"|=~(^*/){[}\\\]-]*)$/.test(lastname))) {
                    if (window.location.href.indexOf("fr_FR") > -1) {
                        $(".reglastname").addClass("is-invalid");
                        $(".reg-form-lname-alert").text("Veuillez entrer un nom valide");
                    }
                    else if (window.location.href.indexOf("nl_NL") > -1) {
                        $(".reglastname").addClass("is-invalid");
                        $(".reg-form-lname-alert").text("Voer een geldige naam in");
                    }
                    else if (window.location.href.indexOf("de_DE") > -1) {
                        $(".reglastname").addClass("is-invalid");
                        $(".reg-form-lname-alert").text("Bitte geben Sie einen gültigen Namen ein");
                    }
                    else {
                        $(".reglastname").addClass("is-invalid");
                        $(".reg-form-lname-alert").text("Please enter a valid name");
                    }
                    $(".reg-form-lname-alert").css("display", "block");
                }
                else if (lastname == "") {
                    if (window.location.href.indexOf("fr_FR") > -1) {
                        $(".reg-form-lname-alert").text("Ce champ est obligatoire.");
                    }
                    else if (window.location.href.indexOf("nl_NL") > -1) {
                        $(".reg-form-lname-alert").text("Dit veld is verplicht.");
                    }
                    else if (window.location.href.indexOf("de_DE") > -1) {
                        $(".reg-form-lname-alert").text("Dieses Feld wird benötigt.");
                    }
                    else {
                        $(".reg-form-lname-alert").text("This field is required.");
                    }
                    $(".reg-form-lname-alert").css("display", "block");
                }
                else {
                    $(".reglastname").removeClass("is-invalid");
                    $(".reg-form-lname-alert").css("display", "none");
                }
            });
            /*Last name alert END*/

            var pass = $('#registration-form-password').val();

            if ($('.header-rtr').length > 0) {
                isRTRPage = true;
            }

            $(".submitbutton").click(function () {
                //alert(3);
                var firstname = $(".regfirstname").val();
                if (!(/^([^0-9&$£?!@#%;:`<>_+"|=~(^*/){[}\\\]-]*)$/.test(firstname))) {
                    // alert("lo");
                    if (window.location.href.indexOf("fr_FR") > -1) {
                        $(".regfirstname").addClass("is-invalid");
                        $("#form-fname-error-alert").text("Veuillez entrer un nom valide");
                    }
                    else if (window.location.href.indexOf("nl_NL") > -1) {
                        $(".regfirstname").addClass("is-invalid");
                        $("#form-fname-error-alert").text("Voer een geldige naam in");
                    }
                    else if (window.location.href.indexOf("de_DE") > -1) {
                        $(".regfirstname").addClass("is-invalid");
                        $("#form-fname-error-alert").text("Bitte geben Sie einen gültigen Namen ein");
                    }
                    else {
                        $(".regfirstname").addClass("is-invalid");
                        $("#form-fname-error-alert").text("Please enter a valid name");
                    }
                    $("#form-fname-error-alert").css("display", "block");
                }

                var lastname = $(".reglastname").val();
                if (!(/^([^0-9&$£?!@#%;:`<>_+"|=~(^*/){[}\\\]-]*)$/.test(lastname))) {
                    if (window.location.href.indexOf("fr_FR") > -1) {
                        $(".reglastname").addClass("is-invalid");
                        $("#form-lname-error-alert").text("Veuillez entrer un nom valide");
                    }
                    else if (window.location.href.indexOf("nl_NL") > -1) {
                        $(".reglastname").addClass("is-invalid");
                        $("#form-lname-error-alert").text("Voer een geldige naam in");
                    }
                    else if (window.location.href.indexOf("de_DE") > -1) {
                        $(".reglastname").addClass("is-invalid");
                        $("#form-lname-error-alert").text("Bitte geben Sie einen gültigen Namen ein");
                    }
                    else {
                        $(".reglastname").addClass("is-invalid");
                        $("#form-lname-error-alert").text("Please enter a valid name");
                    }
                    $("#form-lname-error-alert").css("display", "block");
                }

                $('.error-messaging').text('');
                if (window.location.href.indexOf("fr_FR") > -1) {
                    if ($(".registration input[name='terms']:checkbox").is(':checked') && validatePassword(pass) && !pass.match(/([a-zA-Z0-9])\1\1/g)) { } else if (!$(".registration input[name='terms']:checkbox").is(':checked')) {
                        $(".form-terms-confirm-error").html("Veuillez accepter les termes et conditions pour créer un compte");
                        $(".form-terms-confirm-error").css("display", "block");
                        return false;
                    } else {
                        $("#form-password-error").html("Désolé, le mot de passe fourni ne correspond pas aux contraintes requises.");
                        $("#form-password-error").css("display", "block");
                        return false;
                    }
                }
                else if (window.location.href.indexOf("nl_NL") > -1) {
                    if ($(".registration input[name='terms']:checkbox").is(':checked') && validatePassword(pass) && !pass.match(/([a-zA-Z0-9])\1\1/g)) { } else if (!$(".registration input[name='terms']:checkbox").is(':checked')) {
                        $(".form-terms-confirm-error").html("Accepteer de algemene voorwaarden om een ​​account aan te maken");
                        $(".form-terms-confirm-error").css("display", "block");
                        return false;
                    } else {
                        $("#form-password-error").html("Sorry, het meegeleverde wachtwoord komt niet overeen met de vereiste beperkingen.");
                        $("#form-password-error").css("display", "block");
                        return false;
                    }
                }
                //for Netherland END
                //for Germany START
                else if (window.location.href.indexOf("de_DE") > -1) {
                    if ($(".registration input[name='terms']:checkbox").is(':checked') && validatePassword(pass) && !pass.match(/([a-zA-Z0-9])\1\1/g)) { } else if (!$(".registration input[name='terms']:checkbox").is(':checked')) {
                        $(".form-terms-confirm-error").html("Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen, um ein Konto zu erstellen");
                        $(".form-terms-confirm-error").css("display", "block");
                        return false;
                    } else {
                        $("#form-password-error").html("Das bereitgestellte Kennwort entspricht leider nicht mit den erforderlichen Einschränkungen.");
                        $("#form-password-error").css("display", "block");
                        return false;
                    }
                }
                //for Germany END
                //for English START
                else {
                    if ($(".registration input[name='terms']:checkbox").is(':checked') && validatePassword(pass) && !pass.match(/([a-zA-Z0-9])\1\1/g)) { } else if (!$(".registration input[name='terms']:checkbox").is(':checked')) {
                        $(".form-terms-confirm-error").html("Please accept terms and conditions to create an account");
                        $(".form-terms-confirm-error").css("display", "block");
                        return false;
                    } else {
                        $("#form-password-error").html("Sorry, the provided password does not match the required constraints.");
                        $("#form-password-error").css("display", "block");
                        return false;
                    }
                }
                //for English END
            });

            $(document).on("keyup", '.registration-form-password', function () {
                if ($('.header-rtr').length > 0) {
                    isRTRPage = true;
                }
                pass = $(this).val();

                if (!validatePassword(pass) || pass.match(/([a-zA-Z0-9])\1\1/g)) {
                    $(".password-validation-message").css("display", "block");
                } else {
                    $(".password-validation-message").css("display", "none");
                }
            });
        });
    },

    modalOpen: function () {
        $('.btn-modal').on('click', function () {
            if (!$('#allinonemodal').is(':visible')) {
                $("#allinonemodal").modal('show');
            }
            var modalClass = '.' + $(this).data('modal-class');
            $('.hide-modal').css('display', 'none')
            if (modalClass == '.register-modal') {
                $('.checkout-newsletter-label').addClass('d-none');
                $('.registration-newsletter-label').removeClass('d-none');
            }
            $(modalClass).css('display', 'block');


        })
    },

    modalClose: function () {
        $(".btn-close").click(function () {
            $("#formulario_popup .reg-form-fname-alert, #formulario .reg-form-fname-alert").css("display", "none");
            $("#formulario_popup .reg-form-lname-alert, #formulario .reg-form-lname-alert").css("display", "none");
            $("#formulario_popup .register-form-password-confirm-error, #formulario .register-form-password-confirm-error").css("display", "none");
            $("#formulario_popup .form-terms-confirm-error, #formulario .form-terms-confirm-error").css("display", "none");
            $("#formulario_popup .btn-registration-submit, #formulario .btn-registration-submit").prop("disabled", true);
            $("#formulario_popup .password-validation-message, #formulario .password-validation-message").css("display", "none")
            $("#formulario_popup input, #formulario input").removeClass("is-invalid");
            $("#formulario_popup select, #formulario select").removeClass("is-invalid");
            $(".login input").removeClass("is-invalid");
            $('.register-modal form#formulario_popup, .register-modal form#formulario, .login-modal form.login, .login-register-modal form#formulario_popup, .login-register-modal form#formulario, .login-register-modal form.login').each(function () {
                this.reset();
            });
        });
        $(document).click(function (event) {
            if ($("#allinonemodal").hasClass("show")) {
            }
            else {
                $("#formulario_popup .reg-form-fname-alert, #formulario .reg-form-fname-alert").css("display", "none");
                $("#formulario_popup .reg-form-lname-alert, #formulario .reg-form-lname-alert").css("display", "none");
                $("#formulario_popup .register-form-password-confirm-error, #formulario .register-form-password-confirm-error").css("display", "none");
                $("#formulario_popup .form-terms-confirm-error, #formulario .form-terms-confirm-error").css("display", "none");
                $("#formulario_popup .btn-registration-submit, #formulario .btn-registration-submit").prop("disabled", true);
                $("#formulario_popup .password-validation-message, #formulario .password-validation-message").css("display", "none");
                $(".register-modal form#formulario_popup input, .register-modal form#formulario input, .login-modal form.login input, .login-register-modal form#formulario_popup input, .login-register-modal form#formulario input, .login-register-modal form.login input").removeClass("is-invalid");
                $('.register-modal form#formulario_popup, .register-modal form#formulario, .login-modal form.login, .login-register-modal form#formulario_popup, .login-register-modal form#formulario, .login-register-modal form.login').each(function () {
                    this.reset();
                });
            }
        });
    },

    resetPasswordValidations: function () {
        $('.reset-password-validations').on('click', function () {
            $("#email-form").trigger('reset');
            $("#new-password-reset-form").trigger('reset');
            $('#get-code-button').prop('disabled', true);
            $('#get-code-button').css('display', 'block');
            $('.verification-code-element').css('display', 'none');
            $('.invalid-otp').empty();
            $('.invalid-email').empty();
            $('.invalid-new-password-confirm').empty();
            $('.invalid-new-password').empty();
            $('#submitEmailButton').prop('disabled', true);
            $('.email-sent-text').empty();
            //$('.change-password-success').text('New Password')
            if (window.location.href.indexOf("fr_FR") > -1) {
                $('.change-password-success').text('nouveau mot de passe');
            }
            else if (window.location.href.indexOf("nl_NL") > -1) {
                $('.change-password-success').text('nieuw paswoord');
            }
            else if (window.location.href.indexOf("de_DE") > -1) {
                $('.change-password-success').text('Neues Passwort');
            }
            else {
                $('.change-password-success').text('New Password');
            }
            $('.newpassword-success-message').empty();
        })
    },

    getVerificationLink: function () {
        $(document).on("click", ".get-verification-link", function () {
            var emailField = $(this).closest('form').find('.login-form-email');
            emailField.removeClass('is-invalid');
            var url = $(this).attr('data-href');
            var email = emailField.val();
            if (email === "" || email === undefined) {
                email = $(this).attr('data-emailid');
            }
            if (email === "" || email === undefined) {
                emailField.parent().children('.invalid-feedback').text('This field is required');
                emailField.addClass('is-invalid');
                return false;
            }

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: { email: email },
                success: function (data) {
                    if (!data.success) {
                        $('#form-email-error').text(data.errorMessage);
                        $('#form-email-error').css('display', 'block');
                    } else {
                        $(".resend-confirm-alert").remove();
                        // $(".register-success-msg").before('<div class="email-sent-text resend-confirm-alert2"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">An email has been sent to you. </p><p class="pb-3">Please check your inbox for instructions.</p></div></div>');
                        if (window.location.href.indexOf("fr_FR") > -1) {
                            // alert("new")
                            $(".register-success-msg").before('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">Un email vous a été envoyé.</p><p class="pb-3">Veuillez vérifier votre boîte de réception pour obtenir des instructions.</p></div></div>');
                        }
                        else if (window.location.href.indexOf("nl_NL") > -1) {
                            $(".register-success-msg").before('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">Er is een e-mail naar u verzonden. </p><p class="pb-3">Controleer uw inbox voor instructies.</p></div></div>');
                        }
                        else if (window.location.href.indexOf("de_DE") > -1) {
                            $(".register-success-msg").before('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">Eine E-Mail wurde an Sie gesendet. </p><p class="pb-3">Bitte überprüfen Sie Ihren Posteingang nach Anweisungen.</p></div></div>');
                        }
                        else {
                            $(".register-success-msg").before('<div class="email-sent-text resend-confirm-alert"><div class="success-email-sent px-3 bg-input-myaccound"><p class="pt-3 fw-bold">An email has been sent to you. </p><p class="pb-3">Please check your inbox for instructions.</p></div></div>');
                        }
                        $(".resend-confirm-alert").fadeTo(2000, 500).fadeOut(500, function () {
                            $(".resend-confirm-alert").fadeOut(500);
                        });
                    }
                },
                error: function (err) {

                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                }
            });
            return false;
        });
    },

    getVerificationCode: function () {
        $(document).on("click", "#reset-get-otp, #get-code-button", function () {
            $('.invalid-email').empty();
            $('.email-sent-text').empty();
            var url = $(this).attr('data-href');
            var email = $(this).closest('form').find('#reset-password-email').val();
            if (email === "") {
                $('.invalid-email').text('This field is required');
                $('.invalid-email').css('display', 'block');
                return false;
            }
            getVerificationCodeAjax(url, email);
            return false;
        });
    },

    newPasswordReset: function () {
        $('form.new-password-reset-form').submit(function () {
            $('.invalid-new-password-confirm').empty();
            $('.invalid-new-password').empty();
            if ($('.header-rtr').length > 0) {
                isRTRPage = true;
            }

            var form = $(this);
            var url = form.attr('action');
            var password = $('#newPassword').val();
            var userID = $('#userId').val();
            var clientToken = $('#clientToken').val();
            var passwordConfirm = $('#newPasswordConfirm').val();
            if (!validatePassword(password) || password.match(/([a-zA-Z0-9])\1\1/g)) {
                // $('.invalid-new-password').text('Sorry, the provided password does not match the required constraints.');
                if (window.location.href.indexOf("fr_FR") > -1) {
                    $('.invalid-new-password').text('Désolé, le mot de passe fourni ne correspond pas aux contraintes requises.');
                }
                else if (window.location.href.indexOf("nl_NL") > -1) {
                    $('.invalid-new-password').text('Sorry, het meegeleverde wachtwoord komt niet overeen met de vereiste beperkingen.');
                }
                else if (window.location.href.indexOf("de_DE") > -1) {
                    $('.invalid-new-password').text('Das bereitgestellte Kennwort entspricht leider nicht mit den erforderlichen Einschränkungen.');
                }
                else {
                    $('.invalid-new-password').text('Sorry, the provided password does not match the required constraints.');
                }

                $(".invalid-new-password").css("display", "block");
                return false;
            }
            if (password !== passwordConfirm) {
                // $('.invalid-new-password-confirm').text('Passwords do not match');
                if (window.location.href.indexOf("fr_FR") > -1) {
                    $('.invalid-new-password-confirm').text('Les mots de passe ne correspondent pas');
                }
                else if (window.location.href.indexOf("nl_NL") > -1) {
                    $('.invalid-new-password-confirm').text('Wachtwoorden komen niet overeen');
                }
                else if (window.location.href.indexOf("de_DE") > -1) {
                    $('.invalid-new-password-confirm').text('Passwörter stimmen nicht überein');
                }
                else {
                    $('.invalid-new-password-confirm').text('Passwords do not match');
                }
                $('.invalid-new-password-confirm').css('display', 'block');
                return false;
            }
            if (userID === "" || clientToken === "") {
                return false;
            }
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: 'password=' + $('#newPassword').val() + '&passwordConfirm=' + $('#newPasswordConfirm').val() + '&userId=' + $('#userId').val() + '&clientToken=' + $('#clientToken').val(),
                success: function (data) {
                    if (!data.success) {
                        $('.invalid-new-password-confirm').text(data.errorMessage);
                        $('.invalid-new-password-confirm').css('display', 'block');
                    } else {
                        //$('.change-password-success').text('Successfull!!!')
                        if (window.location.href.indexOf("fr_FR") > -1) {
                            $('.change-password-success').text('Succès !');
                        }
                        else if (window.location.href.indexOf("nl_NL") > -1) {
                            $('.change-password-success').text('Gelukt!');
                        }
                        else if (window.location.href.indexOf("de_DE") > -1) {
                            $('.change-password-success').text('Erfolgreich!');
                        }
                        else {
                            $('.change-password-success').text('Successfull!');
                        }
                        $('.new-password-body').css('display', 'none');
                        $('.newpassword-success-message').empty().append('<p>' + data.successMessage + '</p>' +
                            '<a   class="btn btn-primary btn-block w-100 rounded-0" href=' +
                            data.returnUrl + '>' + data.buttonText + '</a>')
                    }
                },
                error: function (err) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }
                }
            });
            return false;
        });
    },
    login: function () {
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            form.find('.alert-danger').remove();
            var url = form.attr('action');
            var email = form.find('.login-form-email').val();
            if (!validateEmail(email)) {
                //form.find('.login-form-email + .invalid-feedback').text("Please enter a valid email.");
                if (window.location.href.indexOf("fr_FR") > -1) {
                    form.find('.login-form-email + .invalid-feedback').text("Veuillez saisir une adresse e-mail valide");
                }
                else if (window.location.href.indexOf("nl_NL") > -1) {
                    form.find('.login-form-email + .invalid-feedback').text("Voer een geldig e-mailadres in");
                }
                else if (window.location.href.indexOf("de_DE") > -1) {
                    form.find('.login-form-email + .invalid-feedback').text("Bitte geben Sie eine gültige E-Mail Adresse ein");
                }
                else {
                    form.find('.login-form-email + .invalid-feedback').text("Please enter a valid email address");
                }
                form.find('.login-form-email').addClass('is-invalid');
                return false;
            }
            if ($('.page[data-action="Login-Show"]').length === 0) {
                form.find('input[name="redirectUrl"]').remove();
                form.append('<input type="hidden" name="redirectUrl" value="' + location.href + '" />');
            }
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        $('.alert').remove();
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        $('form.registration').submit(function (e) {
            $('.register-form-password-confirm-error').css('display', 'none');
            var form = $(this);
            var DataForm = new FormData();
            var storeName = 'rtr';
            e.preventDefault();
            var url = form.attr('action');
            var email = form.find('.regemailid').val();
            var formData = form.serializeArray();
            var countryCode = form.find('.flag-text.d-none').text();
            $.each(formData, function (key, input) {
                if (input.name === 'dwfrm_profile_customer_phone') {
                    var phone = `${countryCode} ${input.value.replace(/^0/, '')}`;
                    DataForm.append(input.name, phone);
                } else {
                    DataForm.append(input.name, input.value);
                }
            });
            DataForm.append('partnerCode', 'RTR');
            if (form.find('input[name="filename"]').length > 0) {
                var files = store[storeName];
                for (var i = 0; i < files.length; i++) {
                    DataForm.append(files[i].name, files[i]);
                }
            }
            if (!validateEmail(email)) {
                if (window.location.href.indexOf("fr_FR") > -1) {
                    form.find('.regemailid + .invalid-feedback').text("Veuillez saisir une adresse e-mail valide");
                }
                else if (window.location.href.indexOf("nl_NL") > -1) {
                    form.find('.regemailid + .invalid-feedback').text("Voer een geldig e-mailadres in");
                }
                else if (window.location.href.indexOf("de_DE") > -1) {
                    form.find('.regemailid + .invalid-feedback').text("Bitte geben Sie eine gültige E-Mail Adresse ein");
                }
                else {
                    form.find('.regemailid + .invalid-feedback').text("Please enter a valid email address");
                }
                form.find('.regemailid').addClass('is-invalid');
                return false;
            }

            var password = form.find('.registration-form-password').val();
            var confirmPassword = form.find('.registration-form-password-confirm').val();
            if (password !== confirmPassword) {
                if (window.location.href.indexOf("fr_FR") > -1) {
                    $('.register-form-password-confirm-error').text('Confirmer le mot de passe ne correspond pas');
                }
                else if (window.location.href.indexOf("nl_NL") > -1) {
                    $('.register-form-password-confirm-error').text('Bevestig wachtwoord komt niet overeen');
                }
                else if (window.location.href.indexOf("de_DE") > -1) {
                    $('.register-form-password-confirm-error').text('Das Bestätigen des Kennworts stimmt nicht überein');
                }
                else {
                    $('.register-form-password-confirm-error').text('Confirm password does not match');
                }
                $('.register-form-password-confirm-error').css('display', 'block');
                $('.register-form-password-confirm-error').closest('.form-group').find('.form-control').addClass('is-invalid');
                return false;
            }
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                data: DataForm,
                success: function (data) {
                    if (!data.success) {
                        $('form.registration').trigger('login:register:error', data);
                        formValidation(form, data);
                    } else {
                        if (data.rurl === "4") {
                            $('#pills-home-tab').click();
                            $('form').each(function () {
                                this.reset();
                            });
                            // $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">You are successfully registered. Please check your inbox and verify email. ' +
                            // '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            if (window.location.href.indexOf("fr_FR") > -1) {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">Vous êtes inscrit avec succès. Veuillez vérifier votre ' + data.email + 'boîte de réception et vérifier le courrier électronique. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }
                            else if (window.location.href.indexOf("nl_NL") > -1) {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">U bent met succes geregistreerd. Controleer uw ' + data.email + ' inbox en verifieer e-mail. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }
                            else if (window.location.href.indexOf("de_DE") > -1) {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">Sie sind erfolgreich registriert. Bitte überprüfen Sie Ihren ' + data.email + ' Posteingang und überprüfen Sie die E-Mail. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }
                            else {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">You are successfully registered. Please check your ' + data.email + ' inbox and verify email. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }

                        } else {
                            $('form.registration').trigger('login:register:success', data);
                            $('.hide-modal').css('display', 'none');
                            $('.login-modal').css('display', 'block');
                            $('.alert').remove();
                            $('#formulario')[0].reset();
                            //$('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">You are successfully registered. Please check your inbox and verify email. ' +
                            //'<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            if (window.location.href.indexOf("fr_FR") > -1) {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">Vous êtes inscrit avec succès. Veuillez vérifier votre ' + data.email + ' boîte de réception et vérifier le courrier électronique. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }
                            else if (window.location.href.indexOf("nl_NL") > -1) {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">U bent met succes geregistreerd. Controleer uw ' + data.email + ' inbox en verifieer e-mail. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }
                            else if (window.location.href.indexOf("de_DE") > -1) {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">Sie sind erfolgreich registriert. Bitte überprüfen Sie Ihren ' + data.email + ' Posteingang und überprüfen Sie die E-Mail. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }
                            else {
                                $('form.login').prepend('<div class="alert register-success-msg alert-success" role="alert">You are successfully registered. Please check your ' + data.email + ' inbox and verify email. ' +
                                    '<a class="get-verification-link text-primary" href="javascript:void(0);" data-emailid=' + data.email + ' data-href=' + data.verificationLinkUrl + '>' + data.linkText + '</a>' + '</div>');
                            }
                        }
                        // location.href = data.redirectUrl;

                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        $('form.registration').trigger('login:register:error', err.responseJSON);
                        formValidation(form, err.responseJSON);
                        createErrorNotification($('.error-messaging'), (err.responseJSON.error && err.responseJSON.error.length) ? err.responseJSON.error.join('<br/>') : err.responseJSON.errorMessage);
                    }

                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            $('.invalid-otp').empty();
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        $('.invalid-otp').text(data.errorMessage);
                        $('.invalid-otp').css('display', 'block');
                    } else if (data.client_token) {
                        $('.reset-password-modal').css('display', 'none');
                        $('.new-password-modal').css('display', 'block');
                        $('.new-password-body').css('display', 'block');
                        $('#clientToken').val(data.client_token);
                        $('#userId').val(data.userId);

                    }
                },
                error: function (err) {
                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },
    passwordShow: function () {
        $(document).on('click touchend', '.toggle-password', function () {
            $(this).find('i').toggleClass("fa-eye fa-eye-slash");
            var input = $(this).closest('div').find('input');
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
    },
    tabHeading: function () {
        $(document).on('click', '#pills-home-tab', function () {
            //$('#mixed-modal-heading').text('Login');
            if (window.location.href.indexOf("fr_FR") > -1) {
                $('#mixed-modal-heading').text('Connexion');
            }
            else if (window.location.href.indexOf("nl_NL") > -1) {
                $('#mixed-modal-heading').text('Log in');
            }
            else if (window.location.href.indexOf("de_DE") > -1) {
                $('#mixed-modal-heading').text('Einloggen');
            }
            else {
                $('#mixed-modal-heading').text('Login');
            }
        });
        $(document).on('click', '#pills-profile-tab', function () {
            //$('#mixed-modal-heading').text('Create Account');
            if (window.location.href.indexOf("fr_FR") > -1) {
                $('#mixed-modal-heading').text('Créer un compte');
            }
            else if (window.location.href.indexOf("nl_NL") > -1) {
                $('#mixed-modal-heading').text('Maak een account aan');
            }
            else if (window.location.href.indexOf("de_DE") > -1) {
                $('#mixed-modal-heading').text('Benutzerkonto erstellen');
            }
            else {
                $('#mixed-modal-heading').text('Create Account');
            }
            $('.registration-newsletter-label').addClass('d-none');
            $('.checkout-newsletter-label').removeClass('d-none');
        });
    }
};

function displayMessage(data, button) {
    var status;
    if (data.success || !data.error) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
            '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data.message + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

$('.subscribe-email-forms').on('click', function (e) {
    e.preventDefault();
    var url = $(this).data('href');
    var button = $(this);
    var emailId = $('input[name=hpEmailSignUp]').val();
    var csrfToken = $('input[name=csrf_token_footer]').val();
    $(this).attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: 'email=' + emailId + '&csrf_token=' + csrfToken,
        success: function (data) {
            displayMessage(data, button);
            $('input[name=hpEmailSignUp]').val(data.csrf_token);
            $('#join-the-charger')[0].reset();
        },
        error: function (err) {
            displayMessage(err, button);
            $('#join-the-charger')[0].reset();
        },
        complete: function () { }
    });
});

$(document).on('change', '.fileUpload', function () {
    var files = this.files;
    var fileStore = store[$(this).data('store')];

    // Allow upload up to 3 files
    if (!files ||
        files.length > 3 ||
        files.length + fileStore.length > 3) {
        return;
    }

    // Allows upload file under 10MB
    if (files.length > 0) {
        for (var j = 0; j < files.length; j++) {
            var maxSize = parseFloat((files[j].size / 1024 / 1024).toFixed(2)); // unit: MB
            if (maxSize > 10) {
                $('.invalid-upload-message').fadeTo(2000, 500).fadeOut(500, function () {
                    $('.invalid-upload-message').fadeOut(500);
                });
                return;
            }
        }
    }

    fileStore.push.apply(fileStore, files);
    var $this = $(this);
    var imgPreview = $this.closest('.upload').find('.image-uploaded');
    if (fileStore && fileStore.length > 0) {
        $this.closest('.upload').find('label').removeClass('w-100').css('flex', '1 0 0');
        $this.closest('.upload').find('.box-upload').css('gap', '25px');
        $this.closest('.upload').find('.image-uploaded').css('flex', '3 0 0');
        $('.btn-registration-submit').removeClass('disabled');
        for (var i = 0; i < fileStore.length; i++) {
            imgPreview.empty();
            var reader = new FileReader();
            reader.fileName = fileStore[i].name;
            reader.onload = function (e) {
                var fileName = e.target.fileName;
                var displayName = fileName.length > 10 ? fileName.substring(0, 10) + '...' + fileName.substring(fileName.lastIndexOf('.')) : fileName;
                var imgThumbnail = '<div><span data-name="' + e.target.fileName + '" class="delete-image"></span><span>' + displayName + '</span></div>';

                imgPreview.append(imgThumbnail);
                $this.val('');
            };
            reader.readAsDataURL(fileStore[i]);
        }
    }
});

$(document).on('click', '.delete-image', function () {
    var storeName = $('.fileUpload').data('store');
    var imageName = $(this).data('name');
    var parent = $(this).closest('.upload');
    var index = store[storeName].findIndex(function (s) {
        return s.name === imageName;
    });
    if (index !== -1) {
        store[storeName].splice(index, 1);
        $(this).parent().remove();
    }
    if (store[storeName].length === 0) {
        parent.find('label').addClass('w-100');
        parent.find('.image-uploaded').css('flex', '0 0 0');
        parent.find('.box-upload').css('gap', '0');
        $('.btn-registration-submit').addClass('disabled');
    } else {
        $('.btn-registration-submit').removeClass('disabled');
    }
});
